var common = require("../../utiles/common.js");
require("./template/Agreement.less");
var Cookies = require("js-cookie");
var language = Cookies.get("language") ? Cookies.get("language") : "en_US";

module.exports = {
  register: function () {
    document.createElement("reset-password");
    ko.components.register("reset-password", {
      viewModel: function (params) {
        var $this = this;
        var urlParam = common.urlSearch(window.location.href);
        // 如果是密码不符合当前密码策略的情况
        var badPassword = $("body").data("badPassword");
        var type = $("body").data("type")
          ? $("body").data("type").type
          : "LOGIN";
        console.log(type);
        $("body").removeData("badPassword");
        $this.phoneToken = urlParam.token;
        $this.errorMessage = ko.observable("");
        $this.verifyId = ko.observable("");
        $this.token = ko.observable("");
        $this.codeMsg = ko.observable("发生验证码");
        $this.step = ko.observable("");
        $this.qualifyName = ko.observable("");
        $this.tel = ko.observable("");
        console.log(badPassword);
        var cryptKey;
        if (sessionStorage.getItem("cryptKey")) {
          cryptKey = sessionStorage.getItem("cryptKey");
        } else {
          cryptKey = "04" + common.fetch("/auth/flow/login/getSm2PubK").data;
        }
        if (sessionStorage.getItem("badReason")) {
          common.errorAlert(sessionStorage.getItem("badReason"));
          sessionStorage.removeItem("badReason");
        }
        $this.step("badPassword");
        if (badPassword) {
          $this.token(badPassword.token);
          $this.errorMessage(badPassword.reason);
          $this.step("badPassword");
        } else {
          $this.step(params.step);
        }
        if (params.step == "update") {
          common.fetch("/auth/credential/listCredential", {
            type: "GET",
            query: {},
            handleError: function (data) {
              $this.errorMessage(data.message);
            },
            success: function (result) {
              $this.policyList = result.data;
              console.log($this.policyList);
              $this.qualifyName(result.data[0].qualifyName);
            },
          });
        }

        // $this.step("mail");
        $this.goStep = function (newStep) {
          $this.step("blank");
          $this.formItems = [];
          $this.step(newStep);
          if (newStep == "updateOptions") {
            $this.verify();
            type = "FORGET";
          }
        };

        //判断是否绑定手机号
        $this.verify = function () {
          var res = common.fetch("/auth/personSubject/loginPerson").data;
          if (res && res.individualData && res.individualData.phone) {
            var reg = /1(\d{2})\d{4}(\d{4})/g;
            $this.tel(res.individualData.phone.replace(reg, "1$1****$2"));
          } else {
            common.errorAlert("未绑定手机号,请先绑定手机号");
          }
        };

        //发送短信
        $this.noteSM = function () {
          console.log($this.formItems);
          var validationResult = common.validateAll($this.formItems);
          if (validationResult.valid) {
            if ($this.step() == "options") {
              var params = $(".content.options input").serializeObject();
            } else {
              var params = $(".content.updateOptions input").serializeObject();
            }
            delete params.verifyCode;
            console.log(params);
            common.fetch("/auth/credential/validateVerifyCode", {
              type: "POST",
              data: JSON.stringify(params),
              handleError: function (data) {
                $("img.verifyImg").attr(
                  "src",
                  "/auth/verification/img?type=FORGET_PWD&random=" +
                    Math.random()
                );
                common.errorAlert(data.message);
              },
              success: function (result) {
                $this.errorMessage("");

                $this.verifyId = result.data.verifyId;
                if ($this.step() == "options") {
                  $this.step("badPassword");
                } else {
                  $this.step("updateBadPassword");
                }
              },
            });
          } else {
            //$this.errorMessage(validationResult.msg)
          }
        };
        // 发送新的密码
        $this.badPassword = function () {
          var validationResult = common.validateAll($this.formItems);
          if (validationResult.valid) {
            if ($this.step() == "updateBadPassword") {
              var params = $(
                ".content.updateBadPassword input"
              ).serializeObject();
            } else {
              var params = $(".content.badPassword input").serializeObject();
            }
            if (!(params.agreement && params.agreement === "on")) {
              common.message(
                "error",
                commonLocal.ChangePassword.pleaseAgreement1
              );
              return false;
            }
            delete params.repeatPassword;
            if ($this.token()) {
              params.token = $this.token();
            } else {
              params.token = $this.verifyId;
            }
            params.password = common.sm2.doCrypt(cryptKey, params.password);
            params.type = type;
            console.log(params);
            common.fetch("/auth/credential/resetPassword", {
              type: "POST",
              data: JSON.stringify(params),
              handleError: function (data) {
                $("img.verifyImg").attr(
                  "src",
                  "/auth/verification/img?type=FORGET_PWD&random=" +
                    Math.random()
                );
                $this.errorMessage(data.message);
              },
              success: function (result) {
                console.info("result", result);
                $this.errorMessage("");
                if ($this.step() == "updateBadPassword") {
                  $this.step("updateFinished");
                } else {
                  $this.step("finished");
                }
                if (result && result.data && result.data.type == "LOGIN") {
                  common.redirectTo(result.data.redirectUrl);
                }
              },
            });
          } else {
            // $this.errorMessage(validationResult.msg)
          }
        };
        //修改密码
        $this.update = function () {
          var validationResult = common.validateAll($this.formItems);
          if (validationResult.valid) {
            //common.base64.encode
            var params = $(".content.update input").serializeObject();
            params.newPwd = common.sm2.doCrypt(cryptKey, params.newPwd);
            params.originalPwd = common.sm2.doCrypt(
              cryptKey,
              params.originalPwd
            );
            params.dataTypeQualifyName = $this.qualifyName();
            if (common.getStorage()) {
              params.individualId = common.getStorage().user.individualId;
            }
            delete params.newPwdConfirm;
            common.fetch("/auth/credential/changePassword", {
              type: "POST",
              data: JSON.stringify(params),
              handleError: function (data) {
                $this.errorMessage(data.message);
              },
              success: function (result) {
                $this.errorMessage("");
                $this.step("updateFinished");
              },
            });
          } else {
            // $this.errorMessage(validationResult.msg)
          }
        };

        //设置手机号
        $this.setPhone = function () {
          var query = $(".content.set_phone input").serializeObject();
          console.log(query);

          common.fetch("/auth/credential/resetPhone", {
            type: "POST",
            data: JSON.stringify({
              phone: query.phone,
              token: urlParam.token,
              smsCode: query.smsCode,
            }),
            handleError: function (data) {
              $this.errorMessage(data.message);
            },
            success: function (result) {
              $this.errorMessage("");
              $this.step("updateFinished");
            },
          });
        };
        // $this.closewin = function () {
        //     if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
        //         window.location.href = "about:blank";
        //         window.close();
        //     } else {
        //         window.opener = null;
        //         window.open("", "_self");
        //         window.close();
        //     }
        // }
      },
      template: require("./template/ResetPassword.html"),
    });
    document.createElement("pwd-des");
    ko.components.register("pwd-des", {
      viewModel: function (params) {
        var $this = this;
      },
      template: require("./template/PasswordDes.html"),
    });
    document.createElement("agreement");
    ko.components.register("agreement", {
      viewModel: function (params) {
        var $this = this;
        $this.name = params.name;
        $this.checked = ko.observable(false);
        layui.use(["layer", "jquery"], function () {
          var layer = layui.layer;
          var $ = layui.jquery;

          $this.layerModal = function () {
            layer.open({
              type: 1, // page类型
              shadeClose: false,
              content: document.getElementById($this.name + "_" + language)
                .innerHTML,
              scrollbar: false,
              id: "agreement_content_" + language,
              title: commonLocal.ChangePassword.pleaseAgreement,
              area:
                window.innerWidth <= 768 ? ["100%", "100%"] : ["80%", "80%"],

              success: function (layero, index) {
                var protocolContent = layero.find(
                  "#agreement_content_" + language
                );
                var agreeBtn = layero.find("#agreeBtn_" + language);

                // 倒计时
                var countdown = 5;
                var timer = setInterval(function () {
                  countdown--;
                  agreeBtn.text(
                    commonLocal.ChangePassword.read3 + "(" + countdown + ")"
                  );

                  if (countdown <= 0) {
                    clearInterval(timer);
                    agreeBtn
                      .removeClass("layui-btn-disabled")
                      .removeAttr("disabled")
                      .addClass("layui-bg-blue")
                      .text(commonLocal.ChangePassword.read3);
                  }
                }, 1000);
                console.log(protocolContent);
                // 监听滚动事件
                protocolContent.on("scroll", function () {
                  var scrollHeight = this.scrollHeight;
                  var scrollTop = this.scrollTop;
                  var clientHeight = this.clientHeight;

                  // 判断是否滚动到底部
                  if (scrollTop + clientHeight >= scrollHeight - 10) {
                    clearInterval(timer);
                    agreeBtn
                      .removeClass("layui-btn-disabled")
                      .removeAttr("disabled")
                      .addClass("layui-bg-blue")
                      .text(commonLocal.ChangePassword.read3);
                  }
                });

                // 同意按钮点击事件
                agreeBtn.on("click", function () {
                  if (!$(this).hasClass("layui-btn-disabled")) {
                    layer.close(index);
                    $this.checked(true);
                  }
                });
              },
            });
          };

          // 点击按钮显示协议弹窗
          $("#openProtocol").on("click", function () {
            $this.layerModal();
          });
          $this.openLayer = function () {
            if ($this.checked()) {
              $this.checked(false);
              return true;
            } else {
              $this.layerModal();
            }
          };
        });
      },
      template: require("./template/Agreement.html"),
    });
    document.createElement("agreement1");
    ko.components.register("agreement1", {
      viewModel: function (params) {
        var $this = this;
        $this.name = params.name;
        $this.checked = ko.observable(false);
        layui.use(["layer", "jquery"], function () {
          var layer = layui.layer;
          var $ = layui.jquery;
          $this.layerModal = function () {
            layer.open({
              type: 1, // page类型
              shadeClose: false,
              content: document.getElementById($this.name + "_" + language)
                .innerHTML,
              id: "agreement1_content_" + language,
              scrollbar: false,
              title: commonLocal.ChangePassword.pleaseAgreement,
              area:
                window.innerWidth <= 768 ? ["100%", "100%"] : ["80%", "80%"],
              success: function (layero, index) {
                var protocolContent = layero.find(
                  "#agreement1_content_" + language
                );
                var agreeBtn = layero.find("#agreeBtn1_" + language);

                // 倒计时
                var countdown = 5;
                var timer = setInterval(function () {
                  countdown--;
                  agreeBtn.text(
                    commonLocal.ChangePassword.read3 + "(" + countdown + ")"
                  );

                  if (countdown <= 0) {
                    clearInterval(timer);
                    agreeBtn
                      .removeClass("layui-btn-disabled")
                      .removeAttr("disabled")
                      .addClass("layui-bg-blue")
                      .text(commonLocal.ChangePassword.read3);
                  }
                }, 1000);
                console.log(protocolContent);
                // 监听滚动事件
                protocolContent.on("scroll", function () {
                  var scrollHeight = this.scrollHeight;
                  var scrollTop = this.scrollTop;
                  var clientHeight = this.clientHeight;

                  // 判断是否滚动到底部
                  if (scrollTop + clientHeight >= scrollHeight - 10) {
                    clearInterval(timer);
                    agreeBtn
                      .removeClass("layui-btn-disabled")
                      .removeAttr("disabled")
                      .addClass("layui-bg-blue")
                      .text(commonLocal.ChangePassword.read3);
                  }
                });

                // 同意按钮点击事件
                agreeBtn.on("click", function () {
                  if (!$(this).hasClass("layui-btn-disabled")) {
                    layer.close(index);
                    $this.checked(true);
                  }
                });
              },
            });
          };

          // 点击按钮显示协议弹窗
          $("#openProtocol1").on("click", function (e) {
            e.preventDefault();
            // 阻止冒泡
            e.stopPropagation();
            $this.layerModal();
          });

          $this.openLayer = function () {
            if ($this.checked()) {
              $this.checked(false);
              return true;
            } else {
              $this.layerModal();
            }
          };
        });
      },
      template: require("./template/Agreement1.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/resetPassword/RestPassword.js
// module id = 123
// module chunks = 0